import { capitalise } from "@/utils";

const clearAndUpper = (text) => {
  return text.replace(/_/, " ").toUpperCase();
};

export default (value) => {
  return capitalise(value.replace(/_\w/g, clearAndUpper));
};
